import { notificationsUrl } from "~/utils/apiUrl";
import { buildUrl } from "~/utils/url";
import type {
  NotificationFilters,
  NotificationListResponse,
  NotificationItem,
} from "~/types/Notification";

export const useNotifications = () => {
  const apiFetch = useSanctumClient();

  const fetchNotifications = async (
    filters: NotificationFilters = {},
    page: number = 1,
  ) => {
    const params = new URLSearchParams();

    if (page) params.append("page", page.toString());
    if (filters.per_page) params.append("per_page", filters.per_page.toString());
    if (filters.unread) params.append("unread", "true");
    if (filters.notification_type) {
      params.append("notification_type", filters.notification_type);
    }
    if (filters.status) params.append("status", filters.status);

    const queryString = params.toString();
    const url = `${notificationsUrl.list}${queryString ? "?" + queryString : ""}`;

    return await apiFetch<NotificationListResponse>(url);
  };

  const markNotificationAsRead = async (id: number) => {
    const url = buildUrl(notificationsUrl.read, { id });
    return await apiFetch<{ data: NotificationItem }>(url, {
      method: "POST",
    });
  };

  const markAllNotificationsAsRead = async () => {
    return await apiFetch<{ updated: number }>(notificationsUrl.readAll, {
      method: "POST",
    });
  };

  return {
    fetchNotifications,
    markNotificationAsRead,
    markAllNotificationsAsRead,
  };
};
